// extracted by mini-css-extract-plugin
export var why = "style-module--why--73228";
export var whyBtn = "style-module--why-btn--6d0b4";
export var whyTitle = "style-module--why-title--f53ca";
export var why_icon = "style-module--why_icon--09ca8";
export var why_inner = "style-module--why_inner--8eaa5";
export var why_innerItem = "style-module--why_inner-item--155aa";
export var why_innerItem_desc = "style-module--why_inner-item_desc--c0a4d";
export var why_innerItem_icon = "style-module--why_inner-item_icon--78a93";
export var why_innerItem_text = "style-module--why_inner-item_text--9058c";